import FieldProto from './field-proto';

export default class SystemFieldProto extends FieldProto {

    public entityType   : any
    public valueType   : any

    constructor(entityType:any) {
        super();

        // system entity type i.e. project or task t.e. dlya chego etot field primenyaetsya
        this.entityType = entityType;

        // should be set in system field constructor
        this.type = undefined;
        this.valueType = gd.const.fields.valueType.STRING;
    }

    get label() {
        return gd.const.fields[this.type!].label;
    }

    get description() {
        return gd.const.fields[this.type!].description;
    }

    normalizeCSVValue(value:any) {
        console.error(this.type+" getValueFromCSV not implemented");
        return value;
    }

    getValueType() {return this.valueType}
}
